// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type KontaktaufnahmenListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetKontaktaufnahmenByKontaktaufgabeId(): (
  kontaktaufnahmeId: string
) => Promise<KontaktaufnahmenListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (kontaktaufnahmeId) =>
      (await getAPI()).kontaktaufnahme.getKontaktaufnahmenByKontaktaufgabeId({
        kontaktaufnahmeId,
      }),
    [getAPI]
  );
}
